import styled from 'styled-components';

export const BenefitsBlockWrapper = styled.div(
  props => `
    width: 100%;
    background: ${props.theme.colors.blue.bgBlue};
  `
);

export const BenefitsBlockInner = styled.div(
  props => `
    padding: ${props.theme.spacing.large.l30};

    @media only screen and (min-width:320px) and (max-width: 767px){
      padding: ${props.theme.spacing.large.l30};
    }
  `
);

export const BenefitHeader = styled.div(
  props => `
    font-size: 3.5rem;
    color: ${props.theme.colors.blue.dark};
    font-weight: ${props.theme.font.fontWeight.black};
    text-align: center;
    @media only screen and (min-width:320px) and (max-width: 767px){
      font-size: ${props.theme.font.large.font18};
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
      font-size: ${props.theme.font.large.font26};
    }
  `
);

export const BenefitSubHeader = styled.div(
  props => `
    font-size: ${props.theme.font.large.font18};
    font-weight: ${props.theme.font.fontWeight.normal};
    color: ${props.theme.colors.grey.base};
    text-align: center;
    line-height: 1.3;
    @media only screen and (min-width:320px) and (max-width: 767px){
      font-size: ${props.theme.font.base};
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
      font-size: ${props.theme.font.large.font16};
    }
  `
);

export const BenefitsBlock = styled.div(
  props => `
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: ${props.theme.spacing.large.l50};
    @media only screen and (min-width:320px) and (max-width: 767px){
      flex-direction: column;
      justify-content: flex-start;
      margin: ${props.theme.spacing.base} 0;
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
      margin: ${props.theme.spacing.large.l20} 0;
    }
  `
);

export const BenefitWrapper = styled.div(
  props => `
    display: flex;
    width: 30rem;
    flex-direction: column;
    margin: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l50};
    &:last-of-type{
      border-bottom: none;
    }
    @media only screen and (min-width:320px) and (max-width: 767px){
      width: 100%;
      margin: 0;
      padding-bottom: ${props.theme.spacing.large.l15};
      padding-top: ${props.theme.spacing.large.l15};
      flex-direction: row;
      border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
      

    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
      margin: ${props.theme.spacing.base};
    }
  `
);

export const IconWrapper = styled.div(
  props => `
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: ${props.theme.spacing.large.l15};
    @media only screen and (min-width:320px) and (max-width: 767px){
      margin-bottom: 0;
      width:6rem;
      justify-content: flex-start;
    }
  `
);

export const IconInnerWrap = styled.div(
  props => `
    width:8rem;
    height: 8rem;
    @media only screen and (min-width:320px) and (max-width: 767px){
      width:3.7rem
      height: 3.7rem
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
      width:6rem;
      height: 6rem;
    }
  `
)

export const TextWrapper = styled.div(
  props => `
    font-size: ${props.theme.font.large.font18};
    color: ${props.theme.colors.grey.dark3};
    text-align: center;
    span {
      font-weight: ${props.theme.font.fontWeight.bold};
    }
    @media only screen and (min-width:320px) and (max-width: 767px){
      font-size: ${props.theme.font.large.font18};
      width:80%;
      text-align:left;
      span {
        font-weight: ${props.theme.font.fontWeight.bold};
      }
    }
  `
);
